import BusinessIcon from '@mui/icons-material/Business'
import ContactMailIcon from '@mui/icons-material/ContactMail'
import PaidIcon from '@mui/icons-material/Paid'
import PhotoFilterIcon from '@mui/icons-material/PhotoFilter'
import RequestQuoteIcon from '@mui/icons-material/RequestQuote'
import SnippetFolderIcon from '@mui/icons-material/SnippetFolder'
import StorefrontIcon from '@mui/icons-material/Storefront'

export const ProjectIcon = SnippetFolderIcon
export const ContactIcon = ContactMailIcon
export const ClientIcon = BusinessIcon
export const VendorIcon = StorefrontIcon
export const RfqIcon = PhotoFilterIcon
export const QuoteIcon = RequestQuoteIcon
export const PaymentIcon = PaidIcon
